"use client";
import Link from "next/link";
import { ChevronRight } from "@deemlol/next-icons";
import DOMPurify from "isomorphic-dompurify";
import { usePathname } from "next/navigation";

type BlogIntroProps = {
  selectedBlogName: string | undefined;
};

export default function BlogBreadcrumb({ selectedBlogName }: BlogIntroProps) {
  const pathname = usePathname();
  const currentUrl = `https://www.konstantinfo.com${pathname || ""}`;

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.konstantinfo.com",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Blog",
        item: "https://www.konstantinfo.com/blog/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: selectedBlogName
          ? DOMPurify.sanitize(selectedBlogName, { ALLOWED_TAGS: [] })
          : "Blog Detail",
        item: currentUrl,
      },
    ],
  };

  return (
    <div className="w-[calc(100%_-_5%)] md:w-[calc(100%_-_10%)] max-w-[2500px] mx-auto mt-3 md:mt-6">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <nav
        aria-label="Breadcrumb"
        className="min-h-[32px] py-2 px-4 md:px-5 flex items-center gap-2 md:gap-3 
                   text-[14px] md:text-[16px] text-black/60 
                   border shadow-[0_2px_12px_0_rgba(0,0,0,0.15)] 
                   rounded-[999px] border-solid border-white 
                   w-fit max-w-full"
      >
        <Link
          href="/"
          aria-label="Go to homepage"
          className="hover:text-black shrink-0"
        >
          Home
        </Link>
        <ChevronRight size={18} className="shrink-0" color="#000000ff" />

        <Link
          href="/blog"
          aria-label="Read more blog page"
          className="hover:text-black shrink-0"
        >
          Blog
        </Link>
        <ChevronRight size={18} className="shrink-0" color="#000000ff" />

        <span
          className="text-black truncate font-medium"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedBlogName ?? "") }}
        />
      </nav>
    </div>
  );
}
